import { useEffect } from "react"
import ArrowBackButton from "../../../components/button/ArrowBackButton"
import useProjectTotalSummary from "./useProjectTotalSummary"
import { useAuth } from "../../../hooks/useAuth"
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import Loading from "../../../components/loading/Loading"
import ButtonRating from "../../../components/button/ButtonRating"
import { useParams } from "react-router-dom"

const ProjectTotalSummary = () => {
    const {
        payload,
        getAllSummary,
        loadingPageState
    } = useProjectTotalSummary()
    const {
        getCurrentUser
    } = useAuth()

    const params = useParams();

    useEffect(() => {
        let user = getCurrentUser()
        if (user.ID) {
            getAllSummary(user.ID, params.project_id)
        }
    }, [])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            {
                payload ?
                <>       
                    <div style={{ marginBottom: '16px' }}>
                        <ArrowBackButton
                            title={"Calibration Results"}
                        />
                    </div>
                    
                    {/* Single Card for Chart and Table */}
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        padding: '20px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                        border: '1px solid #f0f0f0'
                    }}>
                        {/* Chart Section */}
                        <div style={{ marginBottom: '24px' }}>
                            <div className="flex-row align-items-center table-responsive">
                                <table className="table align-items-center">
                                    <tbody>
                                        <ComposedChart width={1100} height={280} data={payload}>
                                            <XAxis dataKey="Rating" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <CartesianGrid stroke="#f5f5f5" />
                                            <Bar name="Actual Rating" dataKey="ActualRating" barSize={20} fill="#bebebe" />
                                            <Bar name="Calibrated Rating" dataKey="CalibratedRating" barSize={20} fill="#02B4CC" />
                                            <Line type="monotone" dataKey="Guidance" stroke="#ff7300"/>
                                        </ComposedChart>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Table Section */}
                        <div className="table-responsive">
                            <table className="table align-items-center">
                                <thead>
                                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                                        <th className="text-center" style={{ fontWeight: 600, color: '#495057', padding: '8px', fontSize: '14px' }}>Rating</th>
                                        <th className="text-center" style={{ fontWeight: 600, color: '#495057', padding: '8px', fontSize: '14px' }}>Guidance</th>
                                        <th className="text-center" style={{ fontWeight: 600, color: '#495057', padding: '8px', fontSize: '14px' }}>Actual Rating</th>
                                        <th className="text-center" style={{ fontWeight: 600, color: '#495057', padding: '8px', fontSize: '14px' }}>Calibrated Rating</th>
                                        <th className="text-center" style={{ fontWeight: 600, color: '#495057', padding: '8px', fontSize: '14px' }}>Variance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    payload && payload.map((data) => (
                                        <tr key={data.Rating} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                            <td className="text-center" style={{ padding: '8px', color: '#495057', fontSize: '14px' }}>{data.Rating}</td>
                                            <td className="text-center" style={{ padding: '8px', color: '#495057', fontSize: '14px' }}>{data.Guidance}</td>
                                            <td className="text-center" style={{ padding: '8px', color: '#495057', fontSize: '14px' }}>{data.ActualRating}</td>
                                            <td className="text-center" style={{ padding: '8px' }}> <ButtonRating value={<b>{data.CalibratedRating}</b>} rating={data.Rating} all={true}/></td>
                                            <td className="text-center" style={{ padding: '8px', color: '#495057', fontSize: '14px' }}>{data.Variance}</td>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>:
                <Loading/>
            }
        </div>
    )
}

export default ProjectTotalSummary